import { Action, createReducer, on } from '@ngrx/store';
import { PrinterBrandItemEssential, PrinterBrandListResponse } from '../../../api/models';
import { ILoaderActionPayload, LoadingState } from '../models/loader.model';
import { brandsActions } from './brand-actions';

export interface BrandsState {
  brands: {
    state: ILoaderActionPayload;
    data?: PrinterBrandListResponse;
  };

  single: {
    state: ILoaderActionPayload;
    data?: PrinterBrandItemEssential;
  };
}

const initialState: BrandsState = {
  brands: { state: { value: LoadingState.NONE } },
  single: { state: { value: LoadingState.NONE } },
};
const reducer = createReducer(
  initialState,
  on(brandsActions.loadBrands, (state) => ({
    ...state,
    brands: { state: { value: LoadingState.LOADING } },
  })),
  on(brandsActions.loadDoneBrands, (state, props) => ({
    ...state,
    brands: { state: props.state, data: props.data },
  })),
  //single
  on(brandsActions.single, (state) => ({
    ...state,
    single: { state: { value: LoadingState.LOADING } },
  })),
  on(brandsActions.singleDone, (state, props) => ({
    ...state,
    single: { state: props.state, data: props.data },
  })),
  on(brandsActions.singleSetState, (state, props) => ({
    ...state,
    single: { state: props.state },
  })),
);

export function brandsReducer(state: BrandsState | undefined, action: Action) {
  return reducer(state, action);
}
